import styled from '@emotion/styled';

export const LoaderContainer = styled.div`
  margin: 0 auto;
`;
